"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearEntitlements = exports.saveEntitlements = exports.loadEntitlements = void 0;
const immutable_1 = require("immutable");
const sessionStorageEx = __importStar(require("utils/sessionStorageEx"));
const core_1 = require("companion-app-components/utils/core");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const loadEntitlements = () => {
    const entitlementsStore = core_1.localPreferences.getEntitlements() || sessionStorageEx.getEntitlements();
    if (entitlementsStore) {
        entitlementsStore.resourcesById = (0, immutable_1.Map)(entitlementsStore.resourcesById).map((entitlement) => entitlements_1.entitlementsTypes.mkEntitlement(entitlement));
    }
    return entitlementsStore;
};
exports.loadEntitlements = loadEntitlements;
const saveEntitlements = (entitlementsStore) => {
    sessionStorageEx.setEntitlements(entitlementsStore);
    if (core_1.localPreferences.getKeepLoggedIn()) {
        core_1.localPreferences.setEntitlements(entitlementsStore);
    }
    else {
        core_1.localPreferences.removeEntitlements();
    }
};
exports.saveEntitlements = saveEntitlements;
const clearEntitlements = () => {
    sessionStorageEx.removeEntitlemets();
    core_1.localPreferences.removeEntitlements();
};
exports.clearEntitlements = clearEntitlements;
